import VoiceAssistants from '@app/components/VoiceAssistants/VoiceAssistants'

export default VoiceAssistants
